import { useCallback } from 'react';

import { getGTMConfig } from '@/data/events/handlers/gtm';
import { useSettings } from '@/data/Settings';
import { getStoreDataByPhysicalStoreId } from '@/data/utils/commonIntegrationUtils';
import { useCurrentPhysicalStoreId } from 'presentation/events/hooks/useCurrentPhysicalStoreId';
import { triggerGA4Event } from 'presentation/events/services/ga4EcommerceService';
import { getReferrerForTracking } from 'presentation/events/utils/ga4Utils';

import { SendGA4EventProps } from './types';
import { buildGA4PageViewEventPayload } from './utils';

export const useTrackPageViewGA4 = () => {
	const { settings } = useSettings();
	const { physicalStoreId } = useCurrentPhysicalStoreId();

	return useCallback(
		({ userId, isLoggedIn }: SendGA4EventProps) => {
			const { ga4 } = getGTMConfig(settings);

			if (!ga4) return;

			if (!physicalStoreId) return;

			const storeData = getStoreDataByPhysicalStoreId(physicalStoreId);

			const payload = buildGA4PageViewEventPayload({
				shopCity: storeData?.city ?? null,
				shopName: storeData?.storeName ?? null,
				shopState: storeData?.stLocName ?? null,
				userId,
				isLoggedIn,
				referrer: getReferrerForTracking(),
			});

			triggerGA4Event(payload);
		},
		[settings, physicalStoreId]
	);
};
